module.exports = __webpack_public_path__ + "img/hand-back-point-up.08d67cf7.svg";